import styled from 'styled-components'

import fonts from '../../theme/fonts'
import { textStyles } from '../../theme'

export const Container = styled.footer`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1rem;
  padding: 20px;
  background-color: #f8f8f8;
  border-top: 1px solid #e0e0e0;
  margin-top: auto;

  @media (max-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    gap: 0.5rem;
    padding: 16px;
  }
`

export const CookieButton = styled.button`
  ${fonts.BBRegular}
  background: transparent;
  border: none;
  color: #000;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  &:focus {
    outline: 2px solid #000;
    outline-offset: 2px;
  }
`

export const CookiePolicyButton = styled.button`
  ${fonts.BBRegular}
  background: transparent;
  border: none;
  color: #000;
  padding: 0;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  cursor: pointer;
  text-decoration: none;
  transition: opacity 0.2s ease;

  &:hover {
    opacity: 0.7;
  }

  &:focus {
    outline: 2px solid #000;
    outline-offset: 2px;
  }
`

export const Separator = styled.span`
  ${fonts.BBRegular}
  color: #000;
  font-size: 12px;
  font-weight: 500;
  user-select: none;
`

export const Copyright = styled.span`
  ${textStyles.text}
  color: #000;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.5px;
  text-transform: uppercase;
`
